var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsfdaApproved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12V32C44 38.6274 38.6274 44 32 44H12C5.37258 44 0 38.6274 0 32V12Z",
    fill: "#FFF0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6668 22.8333C28.6668 27 25.7502 29.0833 22.2835 30.2916C22.102 30.3531 21.9048 30.3502 21.7252 30.2833C18.2502 29.0833 15.3335 27 15.3335 22.8333V17C15.3335 16.779 15.4213 16.567 15.5776 16.4107C15.7339 16.2544 15.9458 16.1666 16.1668 16.1666C17.8335 16.1666 19.9168 15.1666 21.3668 13.9C21.5434 13.7491 21.768 13.6663 22.0002 13.6663C22.2324 13.6663 22.457 13.7491 22.6335 13.9C24.0918 15.175 26.1668 16.1666 27.8335 16.1666C28.0545 16.1666 28.2665 16.2544 28.4228 16.4107C28.579 16.567 28.6668 16.779 28.6668 17V22.8333Z",
    stroke: "#DC2626",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 22L21.1667 23.6667L24.5 20.3334",
    stroke: "#DC2626",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsfdaApproved);
export default __webpack_public_path__ + "static/media/USFDA_approved.b67558b01f9e4428b4c3c4ecc0f872da.svg";
export { ForwardRef as ReactComponent };